export interface UpdatableEntity {
  update: (time: number, delta: number) => void;
}

export interface LevelResolutionState {
  pastTrackEnd: boolean;
  allEnemiesSpawned: boolean;
  allGatesSpawned: boolean;
  allWeaponBoxesSpawned: boolean;
  activeEnemyCount: number;
  activeGateCount: number;
  activeWeaponBoxCount: number;
  finaleDefeated: boolean;
}

/** A mission resolves only after its authored beats and live threats are gone. */
export function canResolveLevel(state: LevelResolutionState): boolean {
  return state.pastTrackEnd &&
    state.allEnemiesSpawned &&
    state.allGatesSpawned &&
    state.allWeaponBoxesSpawned &&
    state.activeEnemyCount === 0 &&
    state.activeGateCount === 0 &&
    state.activeWeaponBoxCount === 0 &&
    state.finaleDefeated;
}

export function advanceProgressDistance(
  progressDistance: number,
  scrollSpeed: number,
  deltaMs: number
): number {
  return progressDistance + (scrollSpeed * deltaMs) / 1000;
}

export function updateAndCompactEntities<T extends UpdatableEntity>(
  entities: T[],
  deltaMs: number,
  isActive: (entity: T) => boolean
): void {
  let writeIndex = 0;

  for (let readIndex = 0; readIndex < entities.length; readIndex += 1) {
    const entity = entities[readIndex];
    if (!isActive(entity)) continue;

    entity.update(0, deltaMs);
    if (!isActive(entity)) continue;

    entities[writeIndex] = entity;
    writeIndex += 1;
  }

  entities.length = writeIndex;
}
